import { Providers, Enums } from '@flightscope/baseball-stats';

export default function pitchTypeNameMapper(cat) {
  return Providers.EnumValueProvider.getValue(cat, Enums.PitchType, Enums.PitchType.Unidentified.key, null, 'name');
}
